<template>
    <button
        v-if="editable"
        :class="[
            classes,
            attributeClasses,
            { 'bg-primary text-primary-text': selected },
            { 'hover:bg-primary-hover hover:text-primary-text': !selected },
            'cursor-pointer transition duration-button-hover focus-style',
        ]"
        @click="() => $emit('click')"
        v-text="text"
        ref="attribute"
    />
    <span v-else :class="[classes, attributeClasses]" v-text="text" />
</template>

<script>
export default {
    name: 'Attribute',

    emits: ['click'],

    expose: ['focusMethod'],

    props: {
        text: {
            type: String,
            required: true,
        },
        editable: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        classes: {
            type: [String, Array, Object],
            required: false,
        },
    },

    beforeCreate() {
        this.attributeClasses =
            'text-sm uppercase tracking-attribute p-2 bg-attribute rounded-attribute'
    },

    methods: {
        focusMethod() {
            if (this.editable) {
                this.$refs.attribute.focus()
            }
        },
    },
}
</script>
